import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import SwiperCore, { Autoplay,Pagination } from "swiper";
import { Swiper, SwiperSlide} from "swiper/react";
import dashboard from "@/assets/images/Home/dashboard.svg";
import dashboardcn from "@/assets/images/Home/dashboard.svg";
// import { goLoginOrSignUp } from '@/utils/common.js';

SwiperCore.use([Autoplay,Pagination]);



function Carousel({type,openDialog}) {
    const { t } = useTranslation();
    let { i18n } = useTranslation();

     /** 立即参与5周年活动 */
    // const open5ThDialog = () => {
    //   window.location.href = `/${i18n.language}/5thanniversary`;
    // }

    const openAdsPolarDialog = () => {
      window.open('https://www.adspolar.com/cn/?source=xmp', '_blank')
    }
    return (
      <div className={`Carousel ${i18n.language}`}>
        <div className="carousel_container">
        <Swiper
              loop
              centeredSlides={true}
              centeredSlidesBounds={true}
              speed={600}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              modules={[Pagination]}
              noSwiping={true}
        >
            {/* <SwiperSlide className="third_carousel_item">
              <div className="main_wrapper">
                <div className="content_wrapper">
                  <h1 className="title1" >5 与伦比，登峰造极</h1>
                  <h2 className="title2 font-dinot">5周年特惠福利来袭，限时领取</h2>
                  <div className="text">
                    10.16 - 10.25
                  </div>
                </div>
                <div className="btn_wrapper">
                    <button
                      onClick={() => open5ThDialog()}
                      className={["btn font-bold button_link ", type].join(" ")}
                    >
                    立即参与
                    </button>
                </div>
              </div>
            </SwiperSlide> */}
            <SwiperSlide className={`first_carousel_item ${(type === 'mobile' || i18n.language === 'en') ? 'swiper-no-swiping' : ''}`}>
              <div className="main_wrapper">
                <div className="content_wrapper">
                  <div className="title1" dangerouslySetInnerHTML={{ __html: type === 'mobile' ? t('home.main.carousel1.mobileTitle1') : t("home.main.carousel1.title1") }}></div>
                  <h1 className="title2 font-dinot">{t("home.main.carousel1.title2")}</h1>
                  <div className="text">
                    {t(`${type}.home.main.text`)}
                  </div>
                </div>
                <div className="btn_wrapper">
                    <button
                      onClick={() => openDialog()}
                      className={["btn font-bold button_link ", type].join(" ")}
                    >
                    {t('home.main.carousel1.freeUse')}
                    </button>
                </div>
                <div className="dashboard_wrapper">
                  <img
                    src={i18n.language === "en" ? dashboard : dashboardcn}
                    alt="dashboard"
                  />
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide className="second_carousel_item">
              <div className="main_wrapper">
                <img src={logo} alt="banner" className="banner_logo"/>
                <div className="title_wrapper">
                  <span className="year">2024</span>
                  <h1>巴西市场中轻度手游</h1>
                  <h1>洞察报告</h1>
                  <p className="generalize">市场概况丨买量大盘丨品类洞察丨买量指南</p>
                </div>
                <div className="reportImage_wrapper">
                  <img src={reportImage} alt="reportImage" />
                </div>
                <div className="btn_wrapper">
                    <a
                      target="_blank"
                      href="https://app.jingsocial.com/microFrontend/leadGeneration/jsf-leads/list/contentMarketing/TfXdKALWLyDkNYyvEMngZ7/eF49rgUUtizXaztbDTGiKF"
                      rel="noreferrer"
                      className={["btn font-bold button_link ", type].join(" ")}
                    >
                      领取报告
                    </a>
                </div>
              </div>
            </SwiperSlide> */}

            <SwiperSlide className="fourth_carousel_item">
              <div className="main_wrapper">
              <div className="btn_wrapper">
                <button
                      onClick={() => openAdsPolarDialog()}
                      className={["btn font-bold button_link ", type].join(" ")}
                    >
                    {t('home.main.carousel1.freeUse')}
                    </button>
                </div>
              </div>
            </SwiperSlide>
        </Swiper>
        </div>
      </div>
    );
  }

export default Carousel;
